module.exports = __webpack_public_path__ + "static/media/anvil-impact.eb4dfd04.svg";